export enum TableConfig {
  maxColumnsLimitFromBackEnd = 200,
  DefaultColumnsCount = 200,
  MaxColumnsCount = 300,
  DefaultStartingRowIndex = 0,
  DefaultEndingRowIndex = 500
}
